/* ==========================================================================
   MISTER KEY: Medeco keys and keying add-on
   - Product page: extra keys and "key alike" from the Keys and keying box.
   - Cart: keeps one "Medeco Keyed Alike" line per keyway, quantity = locks - 1,
     and removes extra-key lines whose lock was removed.
   Extra keys and keying are hidden $25 products (handles extra-medeco-key and
   medeco-keyed-alike). Line item properties starting with "_" stay hidden.
   ========================================================================== */
(function () {
  "use strict";

  var CFG = window.MKKeying || {};
  if (!CFG.extraKey || !CFG.ka) return;
  var DRAWER = "cart-drawer";
  var KA_PROP = "Keyed alike";

  function root() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return r || "/";
  }

  function getJSON(url) {
    return fetch(url, { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) throw data;
        return data;
      });
    });
  }

  /* ---------- cart drawer helpers (same markup theme.js uses) ---------- */
  var suppressObserver = 0;

  function applyDrawer(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, "text/html");
    var fresh = doc.querySelector("#cartDrawerContent");
    var live = document.getElementById("cartDrawerContent");
    if (fresh && live) { suppressObserver++; live.innerHTML = fresh.innerHTML; }
    var nd = doc.querySelector("#cartDrawer");
    if (nd) {
      var count = parseInt(nd.getAttribute("data-count"), 10) || 0;
      document.querySelectorAll("[data-cart-count]").forEach(function (el) {
        el.textContent = count; el.classList.toggle("show", count > 0);
      });
      var ld = document.getElementById("cartDrawer");
      if (ld) ld.setAttribute("data-count", count);
    }
  }

  function renderDrawer() {
    return getJSON(root() + "?sections=" + DRAWER).then(function (s) { applyDrawer(s && s[DRAWER]); });
  }

  function openDrawer() {
    var d = document.getElementById("cartDrawer");
    var s = document.getElementById("scrim");
    if (d) d.classList.add("open");
    if (s) s.classList.add("show");
    document.body.style.overflow = "hidden";
  }

  var toastTimer;
  function toast(msg) {
    var t = document.getElementById("toast");
    if (!t) { t = document.createElement("div"); t.id = "toast"; t.className = "toast"; document.body.appendChild(t); }
    t.innerHTML = '<svg class="icon"><use href="#i-check"></use></svg><span></span>';
    t.querySelector("span").textContent = msg;
    requestAnimationFrame(function () { t.classList.add("show"); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove("show"); }, 2600);
  }

  /* ---------- keep the cart consistent ---------- */
  var running = null, rerun = false;

  /* Returns a promise for true if it changed the cart. */
  function reconcile() {
    if (running) { rerun = true; return running; }
    running = getJSON(root() + "cart.js").then(function (cart) {
      var kids = {}, groups = {}, updates = {}, adds = [], seenKa = {};
      cart.items.forEach(function (it) {
        var p = it.properties || {};
        if (p._kid) kids[p._kid] = true;
        if (it.variant_id !== CFG.ka && it.variant_id !== CFG.extraKey && p[KA_PROP] && p._ka_group) {
          groups[p._ka_group] = (groups[p._ka_group] || 0) + it.quantity;
        }
      });
      cart.items.forEach(function (it) {
        var p = it.properties || {};
        if (it.variant_id === CFG.extraKey && p._parent && !kids[p._parent]) updates[it.key] = 0;
        if (it.variant_id === CFG.ka) {
          var g = p._ka_group || "";
          var want = seenKa[g] ? 0 : Math.max(0, (groups[g] || 0) - 1);
          seenKa[g] = true;
          if (it.quantity !== want) updates[it.key] = want;
        }
      });
      Object.keys(groups).forEach(function (g) {
        if (!seenKa[g] && groups[g] > 1) {
          adds.push({ id: CFG.ka, quantity: groups[g] - 1, properties: { Keyway: g, _ka_group: g } });
        }
      });
      var changed = Object.keys(updates).length > 0 || adds.length > 0;
      var chain = Promise.resolve();
      if (Object.keys(updates).length) chain = chain.then(function () { return postJSON(root() + "cart/update.js", { updates: updates }); });
      if (adds.length) chain = chain.then(function () { return postJSON(root() + "cart/add.js", { items: adds }); });
      return chain.then(function () { return changed; });
    }).catch(function () { return false; }).then(function (changed) {
      running = null;
      if (rerun) { rerun = false; return reconcile().then(function (c2) { return changed || c2; }); }
      return changed;
    });
    return running;
  }

  /* After the theme re-renders the drawer (quantity change, remove), fix the cart. */
  function watchDrawer() {
    var d = document.getElementById("cartDrawer");
    if (!d || !("MutationObserver" in window)) return;
    var t;
    new MutationObserver(function () {
      if (suppressObserver > 0) { suppressObserver--; return; }
      clearTimeout(t);
      t = setTimeout(function () {
        reconcile().then(function (changed) { if (changed) renderDrawer(); });
      }, 250);
    }).observe(d, { childList: true, subtree: true });
  }

  /* Checkout from drawer or cart page: save the form, fix the cart, then go. */
  function guardCheckout() {
    document.addEventListener("submit", function (e) {
      var form = e.target;
      var sub = e.submitter;
      if (!form || !sub || sub.name !== "checkout") return;
      if (!/\/cart\/?$/.test(form.getAttribute("action") || "")) return;
      e.preventDefault();
      e.stopPropagation();
      sub.disabled = true;
      var body = new URLSearchParams(new FormData(form));
      /* If the cart changed since the page loaded, Shopify rejects the whole
         update ("Cart changed"), so try again with just the PO number and note. */
      var attrsOnly = new URLSearchParams();
      body.forEach(function (v, k) { if (k.indexOf("attributes[") === 0 || k === "note") attrsOnly.append(k, v); });
      function save(params) {
        return fetch(root() + "cart/update.js", {
          method: "POST", credentials: "same-origin",
          headers: { "Content-Type": "application/x-www-form-urlencoded", Accept: "application/json" },
          body: params.toString()
        }).then(function (r) { if (!r.ok) throw r; return r; });
      }
      save(body).catch(function () { return save(attrsOnly); })
        .then(function () { return reconcile(); })
        .then(function () { window.location.href = root() + "checkout"; })
        .catch(function () {
          var h = document.createElement("input"); h.type = "hidden"; h.name = "checkout"; h.value = "1";
          form.appendChild(h); form.submit();
        });
    }, true);
  }

  /* ---------- product page ---------- */
  function initProduct() {
    var box = document.querySelector("[data-keying]");
    var form = document.getElementById("product-form");
    if (!box || !form) return;

    var group = box.getAttribute("data-group");
    var title = box.getAttribute("data-title") || "";
    var keyPrice = parseInt(box.getAttribute("data-key-price"), 10) || 2500;
    var extraEl = box.querySelector("[data-keying-extra]");
    var kaEl = box.querySelector("[data-keying-ka]");
    var labelEl = box.querySelector("[data-keying-extra-label]");
    var totalEl = box.querySelector("[data-keying-total]");
    var qtyEl = form.querySelector('[name="quantity"]');
    var variants = [];
    var vj = form.querySelector("[data-variants-json]");
    if (vj) { try { variants = JSON.parse(vj.textContent); } catch (err) {} }

    function money(cents) {
      return (window.MK && window.MK.money ? window.MK.money : "${{amount}}")
        .replace(/\{\{\s*\w+\s*\}\}/, (cents / 100).toFixed(2));
    }
    function lockQty() { return Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1); }
    function extras() {
      var n = Math.max(0, Math.min(50, parseInt(extraEl.value, 10) || 0));
      extraEl.value = n;
      return n;
    }
    function keyCount() { return kaEl.checked ? extras() : extras() * lockQty(); }

    function refresh() {
      labelEl.textContent = kaEl.checked ? "Extra keys for the shared key" : "Extra keys for each lock";
      var keys = keyCount();
      if (keys > 0) {
        totalEl.hidden = false;
        totalEl.textContent = keys + (keys === 1 ? " extra key" : " extra keys") + ", " + money(keys * keyPrice) + " added to your order.";
      } else {
        totalEl.hidden = true;
      }
      /* Buy it now skips the cart, so hide it while keys or keying are chosen. */
      var pb = form.querySelector(".shopify-payment-button");
      if (pb) pb.style.display = keys > 0 || kaEl.checked ? "none" : "";
    }

    box.addEventListener("click", function (e) {
      if (e.target.closest("[data-keying-inc]")) { extraEl.value = extras() + 1; refresh(); }
      if (e.target.closest("[data-keying-dec]")) { extraEl.value = Math.max(0, extras() - 1); refresh(); }
    });
    extraEl.addEventListener("input", refresh);
    kaEl.addEventListener("change", refresh);
    form.addEventListener("click", function (e) { if (e.target.closest("#qtyInc, #qtyDec")) setTimeout(refresh, 0); });
    if (qtyEl) qtyEl.addEventListener("input", refresh);

    var adding = false;
    function add(e) {
      e.preventDefault();
      e.stopPropagation();
      if (adding) return;
      adding = true;
      var btn = form.querySelector("[data-add-btn]");
      var sticky = document.getElementById("stickyAdd");
      if (btn) btn.disabled = true;
      if (sticky) sticky.disabled = true;

      var id = parseInt(form.querySelector('[name="id"]').value, 10);
      var v = variants.find(function (x) { return x.id === id; });
      var name = title + (v && v.title && v.title !== "Default Title" ? " (" + v.title + ")" : "");
      var kid = Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
      var props = { _kid: kid, _ka_group: group };
      if (kaEl.checked) props[KA_PROP] = "Yes, " + group;
      /* Shopify lists the last item of an add first, so the keys go in before
         the lock to show the lock on top with its keys under it. */
      var items = [];
      var keys = keyCount();
      if (keys > 0) {
        items.push({ id: CFG.extraKey, quantity: keys, properties: {
          For: name,
          Keys: kaEl.checked ? "Cut to the keyed-alike " + group + " key" : extras() + " per lock",
          _parent: kid, _ka_group: group
        } });
      }
      items.push({ id: id, quantity: lockQty(), properties: props });

      postJSON(root() + "cart/add.js", { items: items })
        .then(function () { return reconcile(); })
        .then(function () { return renderDrawer(); })
        .then(function () { openDrawer(); toast("Added to cart"); })
        .catch(function (err) { toast((err && err.description) || "Couldn’t add to cart"); })
        .then(function () {
          adding = false;
          if (btn) btn.disabled = false;
          if (sticky) sticky.disabled = false;
        });
    }

    /* Capture phase runs before theme.js's own add-to-cart handlers. */
    document.addEventListener("submit", function (e) { if (e.target === form) add(e); }, true);
    document.addEventListener("click", function (e) { if (e.target.closest && e.target.closest("#stickyAdd")) add(e); }, true);
    refresh();
  }

  function start() {
    initProduct();
    watchDrawer();
    guardCheckout();
    if (CFG.cartPage) {
      reconcile().then(function (changed) { if (changed) window.location.reload(); });
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
